/**
 * PromotionSupplierToRiderPage Component
 * 협력사 → 라이더 프로모션 페이지
 *
 * 협력사가 라이더에게 제공하는 프로모션 관리
 * (현재 개발 예정)
 */
import React from "react";

const PromotionSupplierToRiderPage: React.FC = () => {
    return (
        <div className="supplier-selection-page">
            {/* 페이지 제목 */}
            <div className="page-title-wrapper">
                <h1 className="page-title">협력사 → 라이더 프로모션</h1>
            </div>

            {/* 준비 중 안내 */}
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '400px',
                backgroundColor: 'var(--color-white)',
                border: '1px solid var(--color-gray-200)',
                borderRadius: 'var(--border-radius-lg)',
                margin: '20px 0'
            }}>
                <div style={{
                    textAlign: 'center',
                    color: 'var(--color-gray-600)',
                    fontSize: '1.1rem'
                }}>
                    <i className="fas fa-tools" style={{ fontSize: '3rem', marginBottom: '20px', display: 'block' }}></i>
                    <p style={{ fontWeight: 500, marginBottom: '10px' }}>협력사 → 라이더 프로모션 관리 기능</p>
                    <p>곧 추가될 예정입니다.</p>
                </div>
            </div>
        </div>
    );
};

export default PromotionSupplierToRiderPage;
